import globalConstant from './constants';

export const isUserPermitted = (userRoles: { component: string, role: string, isVerified: boolean }[]) => {
    return userRoles?.some((role) => role.component === globalConstant.ORCA && role.isVerified)
}

export const isUserOrca = (user: IUserDetails): boolean | undefined => {
    return user?.roles?.some(roleObj => roleObj.component === globalConstant.ORCA)
}